var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAbstract = function SvgAbstract(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2550"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14.809V10l4.166 2.409a2.775 2.775 0 1 1-4.166 2.4m-4.167-2.4L10 10 5.833 7.592a2.783 2.783 0 1 0 0 4.817M10 5.192V10l4.166-2.408A2.775 2.775 0 1 0 10 5.192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833 7.592a2.775 2.775 0 1 1 4.166-2.4V10zm8.333 4.817a2.774 2.774 0 1 0 0-4.817L9.999 10zm-8.333 0a2.776 2.776 0 1 0 4.166 2.4V10z",
    opacity: 0.3
  }))));
};
export default SvgAbstract;